module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/what-is-vux-virtual-component-21.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/what-is-vux-virtual-component.md
// module id = 596
// module chunks = 189